// daoud brand — catches "GOOD BOY" wherever it renders as plain text and wraps it
// so the sitewide absolute-lowercase rule (daoud-brand-styles.liquid) can't touch it.
// Liquid-level fixes (snippets/daoud-case-exceptions.liquid) handle the render paths
// that support it; this is the safety net for the ones that don't — Shopify's JSON
// template "text" fields only allow {{ }} variable interpolation, not {% render %}
// tags, so a block like the PDP heading can't call the Liquid snippet directly.
(function () {
  var PATTERN = /good boy/i;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, TITLE: 1 };

  function processRoot(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !PATTERN.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName] || parent.closest('.text-case-exception')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var targets = [];
    var n;
    while ((n = walker.nextNode())) targets.push(n);

    targets.forEach(function (textNode) {
      var parts = textNode.nodeValue.split(/(good boy)/i);
      if (parts.length <= 1) return;

      var fragment = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (PATTERN.test(part) && part.length === 8) {
          var span = document.createElement('span');
          span.className = 'text-case-exception';
          span.textContent = 'GOOD BOY';
          fragment.appendChild(span);
        } else if (part) {
          fragment.appendChild(document.createTextNode(part));
        }
      });
      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function run() {
    processRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-scan when content loads after the fact: cart drawer, quick-add modal,
  // section AJAX reloads, theme editor.
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('cart:updated', run);
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = false;
    mutations.forEach(function (m) {
      if (m.addedNodes && m.addedNodes.length) shouldRun = true;
    });
    if (shouldRun) run();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
